// src/ChatRoom.js
import React, { useState, useEffect, useRef } from "react";
import { db } from "./firebase";
import { collection, addDoc, onSnapshot, query, orderBy, serverTimestamp, doc, getDoc } from "firebase/firestore";

function ChatRoom({ currentUser, otherUser }) {
  const [messages, setMessages] = useState([]);
  const [newMsg, setNewMsg] = useState("");
  const [profiles, setProfiles] = useState({});
  const messagesEndRef = useRef(null);

  // Determine chat room ID
  const chatRoomId =
    currentUser.uid > otherUser.uid
      ? currentUser.uid + "_" + otherUser.uid
      : otherUser.uid + "_" + currentUser.uid;

  const messagesRef = collection(db, "chatRooms", chatRoomId, "messages");

  // Fetch profiles for current user and other user
  useEffect(() => {
    const fetchProfiles = async () => {
      const currentUserDoc = await getDoc(doc(db, "users", currentUser.uid));
      const otherUserDoc = await getDoc(doc(db, "users", otherUser.uid));
      setProfiles({
        [currentUser.uid]: currentUserDoc.exists() ? currentUserDoc.data() : {},
        [otherUser.uid]: otherUserDoc.exists() ? otherUserDoc.data() : {},
      });
    };
    fetchProfiles();
  }, [currentUser, otherUser]);

  // Listen for messages in real-time
  useEffect(() => {
    const q = query(messagesRef, orderBy("createdAt"));
    const unsubscribe = onSnapshot(q, (snapshot) => {
      setMessages(snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
    });
    return () => unsubscribe();
  }, [chatRoomId]);

  // Scroll to bottom whenever messages update
  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  const handleSend = async (e) => {
    e.preventDefault();
    if (!newMsg.trim()) return;

    await addDoc(messagesRef, {
      text: newMsg,
      sender: currentUser.uid,
      createdAt: serverTimestamp(),
    });

    setNewMsg("");
  };

  return (
    <div style={{ flex: 1, display: "flex", flexDirection: "column", padding: "10px" }}>
      <h3>Chat with {profiles[otherUser.uid]?.name || otherUser.email}</h3>
      <div
        style={{
          flex: 1,
          overflowY: "auto",
          border: "1px solid #ccc",
          padding: "10px",
          marginBottom: "10px",
        }}
      >
        {messages.map((msg) => {
          const senderProfile = profiles[msg.sender] || {};
          const isCurrentUser = msg.sender === currentUser.uid;
          return (
            <div
              key={msg.id}
              style={{
                display: "flex",
                justifyContent: isCurrentUser ? "flex-end" : "flex-start",
                marginBottom: "10px",
              }}
            >
              {!isCurrentUser && (
                <img
                  src={senderProfile.photoURL || "https://via.placeholder.com/30"}
                  alt="avatar"
                  style={{ width: "30px", height: "30px", borderRadius: "50%", marginRight: "10px" }}
                />
              )}
              <div
                style={{
                  backgroundColor: isCurrentUser ? "#DCF8C6" : "#FFF",
                  padding: "8px 12px",
                  borderRadius: "15px",
                  maxWidth: "70%",
                }}
              >
                {!isCurrentUser && <strong>{senderProfile.name || msg.sender}</strong>}
                <p style={{ margin: 0 }}>{msg.text}</p>
              </div>
              {isCurrentUser && (
                <img
                  src={senderProfile.photoURL || "https://via.placeholder.com/30"}
                  alt="avatar"
                  style={{ width: "30px", height: "30px", borderRadius: "50%", marginLeft: "10px" }}
                />
              )}
            </div>
          );
        })}
        <div ref={messagesEndRef} />
      </div>

      <form onSubmit={handleSend} style={{ display: "flex" }}>
        <input
          type="text"
          value={newMsg}
          onChange={(e) => setNewMsg(e.target.value)}
          placeholder="Type a message..."
          style={{ flex: 1, padding: "8px" }}
        />
        <button type="submit" style={{ marginLeft: "10px", padding: "8px" }}>
          Send
        </button>
      </form>
    </div>
  );
}




export default ChatRoom;
